import { getTagging, getUserInfo } from '../../../Checkout/checkout.utils';
import { QueryClient } from 'react-query';
import {
  IProduct,
  getBestTechFromCoverage,
  organizeBestTechFromServiceAbility,
  retrieveProductTechnology,
} from '@vfit/consumer/data-access';
import { trackWithNewDatalayer } from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';

const trackProposal = (queryClient: QueryClient, product: IProduct) => {
  const bestTech = organizeBestTechFromServiceAbility();
  const bestTechFromCoverage = getBestTechFromCoverage(queryClient);
  const tagging = getTagging('cart', 'fixed', queryClient);
  const fwPrice = bestTechFromCoverage?.fastwebTechnology?.price?.price
    ? [
        ...bestTechFromCoverage.fastwebTechnology.price.price.matchAll(/\d{1,3}(?:,\d{1,2})?€/g),
      ].map((match) => match?.[0] || '')
    : '';
  const fwName = 'fastweb-product';
  const fwId = 'fastweb-product-id';
  trackWithNewDatalayer({
    event: ['cart_view'],
    opts: {
      ...tagging?.opts,
      product_technology: [retrieveProductTechnology() || '', bestTech?.BestTechTechnology || ''],
    },
    cartProduct: {
      ...tagging?.trackingProduct,
      cart_products_category: [product?.category || '', bestTech?.bestTechValue || ''],
      cart_products_id: [product?.offerId?.toString() || '', fwId],
      cart_products_name: [product?.slug || '', fwName],
      cart_products_price: [
        removeCurrency(product?.price || ''),
        removeCurrency(fwPrice?.[0] || ''),
      ],
      cart_products_quantity: ['1', '1'],
      cart_products_technology: [
        retrieveProductTechnology() || '',
        bestTech?.BestTechTechnology || '',
      ],
    },
    pageProduct: {
      ...tagging?.pageProductsInfo,
      product_name: [product?.slug || '', fwName],
      product_price: [removeCurrency(product?.price || ''), removeCurrency(fwPrice?.[0] || '')],
      product_id: [product?.offerId?.toString() || '', fwId],
      product_quantity: '1',
      product_category: [product?.category || '', bestTech?.bestTechValue || ''],
    },
    visitorTrackingOpts: getUserInfo(),
  });
};

export { trackProposal };
